import { editDigits, type DigitEdit, type DigitEditResult } from "./digit-input.ts"

/**
 * 반송장번호 — 서버 `server/src/domain/tracking.ts` 의 사본에 입력칸 편집 규칙을 더한 것이다.
 * 표시·저장 규칙을 고치면 양쪽을 함께 고칠 것.
 *
 * 저장·전송은 숫자만(`495410759314`), 화면은 `####-####-####`(`4954-1075-9314`).
 * 커서를 지키는 편집 규칙은 `digit-input.ts` 에 있다(연락처 칸과 같이 쓴다).
 */

/** 반송장번호는 숫자 12자리다(사가와·야마토 둘 다). */
export const TRACKING_MAX_DIGITS = 12

/** 저장·전송용 모양 — 숫자만, 12자리까지. */
export function trackingDigits(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, TRACKING_MAX_DIGITS)
}

/** 숫자를 네 자리마다 끊는다. 입력 중(자릿수가 덜 찼을 때)에도 쓴다. */
function groupDigits(digits: string): string {
  return digits === "" ? "" : (digits.match(/\d{1,4}/g) as string[]).join("-")
}

/**
 * 보여 주는 모양 — `####-####-####`.
 *
 * 숫자 말고 다른 글자가 섞였거나 12자리를 넘는 옛 값은 손대지 않고 원문 그대로 보여 준다
 * (시트에서 "확인중" 같은 글이 섞여 들어왔다).
 */
export function formatTracking(raw: string | null | undefined): string | null {
  if (raw === null || raw === undefined || raw === "") return null
  if (/[^0-9\s-]/.test(raw)) return raw
  const digits = raw.replace(/\D/g, "")
  if (digits === "" || digits.length > TRACKING_MAX_DIGITS) return raw
  return groupDigits(digits)
}

export type TrackingEdit = DigitEdit
export type TrackingEditResult = DigitEditResult

/** 입력칸 한 번의 편집을 저장 모양(숫자)과 보이는 모양(하이픈)으로 옮긴다. */
export function editTracking(edit: TrackingEdit): TrackingEditResult {
  return editDigits(edit, { digitsOf: trackingDigits, format: groupDigits })
}
